import _ from 'lodash';
import allModelData from '@/admin_models/all';

export const modelData = _.merge({}, allModelData, {
  'AdminUser': {
    label: 'email'
  },
  'AdminUsersRole': {
    label: (item) => item.admin_user.email
  },
  'Station': {
    label: 'name'
  },
  'LocalScenery': {
    label: 'name'
  }
})

export const displayText = (object) => {
  if (object.cn) {
    const label = modelData[object.cn]['label']

    if (typeof label === 'function') {
      return label(object)
    } else {
      return object[label] || object.id
    }
  }
}

